<template>
    <div class="e-container">
        <div v-if="step < 4">
            <el-steps :active="step - 1" simple style="background-color: #ffffff;margin-top: 3vw;" v-if="!replenishId">
                <el-step title="站点信息" @click.native="step > 1 && (step = 1)"></el-step>
                <el-step title="人员稽查" @click.native="step > 2 && (step = 2)"></el-step>
                <el-step title="违章拍照"></el-step>
            </el-steps>
            <div style="height: 10px" v-else>
            </div>
            <div v-if="step === 1">
                <el-form ref="form" label-width="60px" style="margin-top: 5vw;">
                    <el-form-item label="站点">
                        <el-select ref="select" v-model="siteInfo.siteId" placeholder="请选择站点" style="width: 90%" filterable
                                   @hook:mounted="cancalReadOnly"
                                   @visible-change="cancalReadOnly" >
                            <el-option
                                v-for="item in siteList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea"
                                  placeholder="请输入备注"
                                  v-model="siteInfo.remark"
                                  style="width: 90%"
                                  maxlength="200"
                                  show-word-limit
                                  :autosize="{
                                  minRows: 5, maxRows: 5
                              }"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <div class=" e-button-next" @click="next">
                    下一步
                </div>
            </div>
            <div v-if="step === 2">
                <div class="e-photo-box">
                    <div class="e-photo" v-for="(item,index) of photoList" :key="item.fileId"
                         :style="{'background-image':'url(\'' + item.originalUrl + '\')'}"
                         @click="removePhoto('photoList',index)"/>
                    <div class="e-photo-add" @click="openCamera('photoList')" v-if="photoList.length < 6"/>
                </div>
                <div class="e-form-tips">最多可上传6张现场照片,请确保照片中人脸清晰可辨。</div>
                <div class="e-button-next" @click="next">
                    下一步
                </div>
                <input type="file" class="input" style="display: none" id="camera_input_photoList" accept="image/*"
                       capture="camera"
                       @change="cameraImageChange('photoList')">
            </div>
            <div v-if="step === 3">
                <div class="e-photo-box">
                    <div class="e-photo" v-for="(item,index) of illegalList" :key="item.fileId"
                         :style="{'background-image':'url(\'' + item.originalUrl + '\')'}"
                         @click="removePhoto('illegalList',index)"/>
                    <div class="e-photo-add" @click="openCamera('illegalList')" v-if="illegalList.length < 6"/>
                </div>
                <div class="e-illegal-title">违章类别：</div>
                <el-checkbox-group v-model="illegalTypes" style="margin: 0 5vw">
                    <el-checkbox class="e-illegal-checkbox"
                                 v-for="item of dict[this.DictStore.CODE.JX_INSPECT_ILLEGAL_TYPE]" :label="item.value"
                                 :key="'illegal_type_' + item.value">{{ item.label }}
                    </el-checkbox>
                </el-checkbox-group>
                <div class="e-illegal-title">备注：</div>
                <el-input type="textarea"
                          placeholder="请输入备注"
                          v-model="illegalRemark"
                          style="width: 90%;margin-left: 5vw"
                          maxlength="200"
                          show-word-limit
                          :autosize="{
                                  minRows: 5, maxRows: 5
                              }"
                ></el-input>
                <div class="e-button-next" @click="submit">
                    提交
                </div>
                <input v-if="replenishId" type="file" class="input" style="display: none" id="camera_input_illegalList"
                       accept="image/*"
                       multiple="multiple"
                       @change="cameraImageChange('illegalList')">
                <input v-else type="file" class="input" style="display: none" id="camera_input_illegalList"
                       accept="image/*"
                       capture="camera"
                       @change="cameraImageChange('illegalList')">
            </div>
        </div>
        <div v-if="step === 4">
            <div class="e-result-box" v-if="result.cognitiveList.length > 0">
                <div class="e-result-title">
                    已识别
                </div>
                <div class="e-result-item" v-for="item of result.cognitiveList" :key="item.userId">
                    <img :src="item.photo" object-fit="contain"/>
                    <div class="e-result-item-info">
                        <div class="e-user-name">{{ item.name }}
                            <div class="e-user-supplier">{{ item.supplierName }}</div>
                            <div class="e-user-insurance" :class="{'e-expire':item.insuranceExpire}">
                                保险{{ item.insuranceExpire ? '已' : '未' }}过期
                            </div>
                        </div>
                        <div class="e-user-position">{{ item.position }}</div>
                        <div class="e-user-cert-list" v-if="item.fileList">
                            <a v-for="item of item.fileList" @click="toCertDetail(item)" target="_blank"
                               style="padding-right: 3vw">{{ item.name }}</a>
                            <!--                            <a v-for="item of item.fileList" :href="item.originalUrl" target="_blank"-->
                            <!--                               style="padding-right: 3vw">{{ item.name }}</a>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="e-result-box" v-if="result.unCognitiveList.length > 0">
                <div class="e-result-title">
                    未识别
                </div>
                <div class="e-result-item" v-for="item of result.unCognitiveList">
                    <img :src="item.photo" object-fit="contain"/>
                    <div class="e-result-item-info">

                    </div>
                </div>
            </div>
            <div class="e-button-next" @click="toHome">
                完成
            </div>
            <div class="e-dialog-box" v-show="imgUrl || pdfUrl">
                <iframe v-show="imgUrl" :src="imgUrl">

                </iframe>
                <div id="pdf" v-show="pdfUrl">

                </div>
                <div class="el-icon el-icon-close e-close-button" @click="closeDialog"></div>
            </div>
        </div>
        <div v-if="step === 5">
            <div style="width: 100%;text-align: center;margin-top: 50vw;">
                <i class="el-icon el-icon-success" style="color: #409EFF;font-size: 18vw"/>
                <p style="color:#666666;font-size: 5vw">补录成功</p>
            </div>
            <div class="e-button-next" @click="toHome">
                完成
            </div>
        </div>
    </div>
</template>

<script>
import {replenish, saveObj} from "@/apis/jx/inspect";
import {upload} from "@/apis/system/file";
import {info} from "@/apis/system/user";
import {findNearSite} from "@/apis/jx/site";
import GeoUtil from "@/utils/geo-util";
import {setAuthorization} from "@/utils/authorization-store";
import {setUserInfo} from "@/utils/user-info-store";
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'

export default {
    name: "index",

    data() {
        return {
            photoList: [],
            illegalList: [],
            illegalTypes: [],
            illegalRemark: "",
            location: null,
            step: 1,
            dict: {},
            siteList: [],
            siteInfo: {
                siteId: null,
                remark: ""
            },
            result: {
                cognitiveList: [],
                unCognitiveList: []
            },
            replenishId: null,
            pdfUrl: null,
            imgUrl: null
        }
    },

    mounted() {
        let url = window.location.href;
        let queryIndex = url.lastIndexOf("?");
        if (queryIndex >= 0) {
            let params = new URLSearchParams(url.substring(queryIndex + 1));
            setAuthorization({
                loginName: params.get("name"),
                token: params.get("token")
            });
            this.replenishId = params.get("id");
            this.step = 3;
        }

        info().then(res => {
            setUserInfo(res.data);
        });
        this.$emit("setTitle", "现场稽查");
        this.DictStore.list([
            this.DictStore.CODE.JX_INSPECT_ILLEGAL_TYPE
        ]).then((res) => {
            this.dict = res.data;
        });

        if (!this.replenishId) {
            this.getLocation();
        }

        // let lat = "60";
        // let lon = "60";
        // this.location = {
        //     lat,
        //     lon
        // }
        // findNearSite(this.location).then(res => {
        //     this.siteList = res.data;
        // });

        // let result = {
        //     "code": "200", "data": {
        //         "id": "f11f2f940390642e2a3caaa5645ee7ae",
        //         "site": {
        //             "name": "齐龙江哈拉海东里村",
        //             "operator": "联通",
        //             "majorName": "室分",
        //             "cityName": "黑龙江省,齐齐哈尔市",
        //             "address": "黑龙江省齐齐哈尔市龙江县齐龙公路"
        //         },
        //         "user": {"name": "系统管理员", "mobile": "1234"},
        //         "detail": {
        //             "cognitiveCount": 5,
        //             "unCognitiveCount": 0,
        //             "lon": "60",
        //             "lat": "60",
        //             "remark": "",
        //             "illegalFileIds": [],
        //             "illegalTypes": [],
        //             "illegalRemark": "",
        //             "status": "1",
        //             "time": "2022-06-24 10:05:46"
        //         },
        //         "photoList": [{
        //             "id": "9d139d9652eb2588431440e8fa4ebfd6",
        //             "fileId": "bb8bb656aab91e4dbacdb767b28d83d5",
        //             "cognitiveCount": 5
        //         }],
        //         "photoUserList": [{
        //             "photoId": "9d139d9652eb2588431440e8fa4ebfd6",
        //             "userId": "e6c534a4d77e1aeeba7caa2be72f6fd7",
        //             "name": "罗光辉",
        //             "supplierName": "耀辉",
        //             "position": null,
        //             "cert": null,
        //             "insuranceExpire": true,
        //             "mobile": "17872956579",
        //             "scanScore": 100.0,
        //             "faceRect": {"x": 1644, "width": 95, "y": 228, "height": 108},
        //             "fileList": null
        //         }, {
        //             "photoId": "9d139d9652eb2588431440e8fa4ebfd6",
        //             "userId": "bf89425696848316f50279addebc0919",
        //             "name": "高中平",
        //             "supplierName": "耀辉",
        //             "position": "队员1",
        //             "cert": null,
        //             "insuranceExpire": true,
        //             "mobile": "15189187374",
        //             "scanScore": 100.0,
        //             "faceRect": {"x": 1354, "width": 96, "y": 214, "height": 116},
        //             "fileList": null
        //         }, {
        //             "photoId": "9d139d9652eb2588431440e8fa4ebfd6",
        //             "userId": "5e48b1e5f9feb1788218a3b295ded05c",
        //             "name": "耿言中",
        //             "supplierName": "耀辉",
        //             "position": null,
        //             "cert": null,
        //             "insuranceExpire": true,
        //             "mobile": "18655769156",
        //             "scanScore": 100.0,
        //             "faceRect": {"x": 814, "width": 93, "y": 215, "height": 118},
        //             "fileList": null
        //         }, {
        //             "photoId": "9d139d9652eb2588431440e8fa4ebfd6",
        //             "userId": "7a6d0e7578475a395bd5c253aaaff522",
        //             "name": "何敏",
        //             "supplierName": "耀辉",
        //             "position": "何敏",
        //             "cert": null,
        //             "insuranceExpire": true,
        //             "mobile": "13405586270",
        //             "scanScore": 100.0,
        //             "faceRect": {"x": 546, "width": 100, "y": 193, "height": 125},
        //             "fileList": [{
        //                 "fileId": "e5a29dda7577ea30b7a6e575370b5c34",
        //                 "name": "GP04862046044107-青岛信鸿兴20万-2022年04月16日止(5人).pdf",
        //                 "originalUrl": "https://efadmin-1251909535.cos.ap-nanjing.myqcloud.com/upload/724a6c429a064d4fa2b1a4c0ea932d01.pdf"
        //             }, {
        //                 "fileId": "6471b3d62ccbf42b603adec846dbf929",
        //                 "name": "电工证371002198612068510.jpg",
        //                 "originalUrl": "https://efadmin-1251909535.cos.ap-nanjing.myqcloud.com/upload/74b7fb890ac14d2696daa95d269aa54e.jpg"
        //             }]
        //         }, {
        //             "photoId": "9d139d9652eb2588431440e8fa4ebfd6",
        //             "userId": "7569325a89b9772da8bfb578bdf0ee58",
        //             "name": "刘云峰",
        //             "supplierName": "耀辉",
        //             "position": null,
        //             "cert": null,
        //             "insuranceExpire": true,
        //             "mobile": "13052913075",
        //             "scanScore": 100.0,
        //             "faceRect": {"x": 1092, "width": 88, "y": 220, "height": 125},
        //             "fileList": null
        //         }]
        //     }, "message": null
        // }
        // this.resultAnalysis(result.data);
    },

    methods: {
        getLocation(){
            console.log(123);
            GeoUtil.getLocation((res) => {
                let lat = res ? res.coords.latitude : '';
                let lon = res ? res.coords.longitude : '';
                this.location = {
                    lat,
                    lon
                }
                findNearSite(this.location).then(res => {
                    this.siteList = res.data;
                });
            });
        },

        cancalReadOnly(onOff) {
            this.$nextTick(() => {
                if (!onOff) {
                    const {select} = this.$refs;
                    const input = select.$el.querySelector('.el-input__inner');
                    input.removeAttribute('readonly');
                }
            });
        },

        openCamera(name) {
            if (this[name].length >= 6) {
                this.$message.warning("照片数量已达到上限");
                return;
            }
            document.getElementById("camera_input_" + name).click();
        },

        cameraImageChange(name) {
            const loading = this.$loading({
                lock: true,
                text: '正在上传'
            })
            let img = document.getElementById('camera_input_' + name);
            let max = 6 - this[name].length;
            let count = img.files.length > max ? max : img.files.length;
            let endCount = 0;
            for (let i = 0; i < count; i++) {
                upload(img.files[i]).then(res => {
                    this[name].push(res.data);
                }).finally(() => {
                    endCount++;
                    img.value = null;
                    if (endCount === count) {
                        loading.close();
                    }
                });
            }
        },

        removePhoto(name, index) {
            this.$confirm("确定要删除该照片吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this[name].splice(index, 1);
            });
        },

        submit() {
            if (this.replenishId) {
                if (this.illegalList.length === 0) {
                    this.$message.warning("请上传违章照片");
                    return;
                }
            } else {
                if (!this.location) {
                    this.$message.warning("无法获取位置信息");
                    return;
                }
                if (this.photoList.length === 0) {
                    this.$message.warning("请上传现场照片");
                    return;
                }
                if (this.illegalTypes.length > 0 && this.illegalList.length === 0) {
                    this.$message.warning("请上传违章照片");
                    return;
                }
            }

            this.$confirm("确定要提交吗?", "提示", {
                confirmButtonText: "提交",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '正在提交'
                })

                if (this.replenishId) {
                    replenish({
                        id: this.replenishId,
                        illegalFileIds: this.illegalList.map((item) => item.fileId),
                        illegalTypes: this.illegalTypes,
                        illegalRemark: this.illegalRemark
                    }).then(res => {
                        loading.close();
                        this.photoList = [];
                        this.step = 5;
                    }).catch(ex => {
                        loading.close();
                        this.$message.error(ex.message);
                    });
                } else {

                    GeoUtil.getLocation((e) => {
                        let lat = e ? e.coords.latitude : '';
                        let lon = e ? e.coords.longitude : '';
                        this.location = {
                            lat,
                            lon
                        }

                        saveObj({
                            siteId: this.siteInfo.siteId,
                            remark: this.siteInfo.remark,
                            lat: this.location.lat,
                            lon: this.location.lon,
                            photoFileIds: this.photoList.map((item) => item.fileId),
                            illegalFileIds: this.illegalList.map((item) => item.fileId),
                            illegalTypes: this.illegalTypes,
                            illegalRemark: this.illegalRemark
                        }).then((res) => {
                            loading.close();
                            this.photoList = [];
                            this.resultAnalysis(res.data);
                            this.step = 4;
                        }).catch((ex) => {
                            loading.close();
                            this.$message.error(ex.message);
                        });

                    });

                }

            });

        },

        resultAnalysis(data) {
            const loading = this.$loading({
                lock: true,
                text: '正在解析'
            })
            let result = {
                cognitiveList: [],
                unCognitiveList: [],
            };
            data.photoList.forEach(photo => {
                let img = new Image();
                img.setAttribute("crossOrigin", 'Anonymous');
                img.src = this.FileBaseUrl + photo.fileId + "?width=2000&height=2000";
                img.onload = () => {
                    data.photoUserList.forEach(item => {
                        if (item.photoId !== photo.id) {
                            return;
                        }
                        let faceRect = item.faceRect;
                        let canvas = document.createElement('canvas');
                        canvas.height = 500;
                        canvas.width = 400;
                        let ctx = canvas.getContext('2d');
                        let padding = faceRect.width / 2;
                        let x = faceRect.x - padding;
                        let y = faceRect.y - padding;
                        let width = faceRect.width + (padding * 2);
                        let height = width * 1.2;

                        ctx.drawImage(img, x, y, width, height, 0, 0, 400, 500)
                        item.photo = canvas.toDataURL("image/png")

                        if (item.scanScore >= 80) {
                            result.cognitiveList.push({
                                userId: item.userId,
                                name: item.name,
                                supplierName: item.supplierName,
                                position: item.position,
                                insuranceExpire: item.insuranceExpire,
                                photo: item.photo,
                                fileList: item.fileList
                            })
                        } else {
                            result.unCognitiveList.push({
                                photo: item.photo
                            })
                        }

                    })

                    if ((result.cognitiveList.length + result.unCognitiveList.length) === data.photoUserList.length) {
                        this.result = result;
                        loading.close();
                    }
                }

            });
        },

        next() {
            switch (this.step) {
                case 1:
                    if (!this.siteInfo.siteId) {
                        this.$message.warning("请选择站点");
                        return;
                    }
                    break;
                case 2:
                    if (this.photoList.length === 0) {
                        this.$message.warning("请上传现场照片");
                        return;
                    }
                    break;
            }
            this.step++;
        },

        toHome() {
            if (this.replenishId) {
                let url = window.location.href;
                location.replace(url.substring(0, url.indexOf('?')));
            }
            location.reload();
        },

        toCertDetail(file) {
            if (file.originalUrl.endsWith("pdf")) {
                this.pdfUrl = this.FileBaseUrl + file.fileId;
                this.pdfh5 = new Pdfh5('#pdf', {pdfurl: this.pdfUrl, goto: 1})
            } else {
                this.imgUrl = file.originalUrl;
            }
        },

        closeDialog() {
            this.pdfUrl = null;
            this.imgUrl = null;
        }

    }

}
</script>

<style>
.el-message-box {
    width: 80vw !important;
}

.el-step__title {
    font-size: 3.5vw !important;
}

.el-step__icon {
    display: none !important;
}

.el-checkbox__label {
    font-size: 4.2vw !important;
}

.el-select-dropdown {
    max-width: 100%;
}

</style>

<style scoped lang='scss'>
@import 'style.scss';
</style>
